import React from 'react';
import Button from './Button';

const FormSubmitButton = ({
    label,
    loadingLabel = 'Submitting...',
    isLoading = false,
    isDisabled = false,
    className = '',
    ...props
}) => {
    return (
        <Button
            type="submit"
            variant="primary"
            disabled={isDisabled || isLoading}
            isLoading={isLoading}
            className={className}
            {...props}
        >
            {isLoading ? loadingLabel : label}
        </Button>
    );
};

export { FormSubmitButton };
export default FormSubmitButton;
